import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { CrudStoreItemScout } from 'legacy/lut/classes/models/CrudStoreItemScout'

import { CrudStore } from 'core/types/crudStore'

/**
 * Partner data is fetched through crud instances cached by partnerId.
 * Mutations go through the onboarding service, so the crud cache keeps
 * the outdated data until it is dropped explicitly.
 */
const removeCachedQueries = (crudStoreItem: string, cacheKey: string) => {
  if (!cacheKey) {
    return
  }

  const crud = CrudStore.get(crudStoreItem, cacheKey)

  if (crud) {
    crud.removeQueries()
  }
}

export const invalidatePartnerDataCache = (partnerId: string) => {
  removeCachedQueries(CrudStoreItem.PartnerAllData, partnerId)
}

export const invalidatePartnerFlagsCache = (partnerId: string) => {
  removeCachedQueries(CrudStoreItemScout.WW_PartnerFlags, partnerId)
  removeCachedQueries(CrudStoreItem.PartnerFlagsRequests, partnerId)
}

export const invalidatePartnerAttachmentsCache = (partnerId: string) => {
  removeCachedQueries(CrudStoreItem.LegalAttachments, partnerId)
}
